import {useState,useEffect} from 'react'
// import useGetSavedFoldList from '../../hooks/useGetSavedFoldList';
import useMarkAction from '../../hooks/useMarkAction'
export const MarkModal = (props) => {
    const {markData, loading, data, savedFoldListRefresh} = props 
    // const {loading, data, savedFoldListRefresh} = useGetSavedFoldList()
    const [createFoldForm, setCreateFoldForm] = useState(false)
    const [nameEmpty, setNameEmpty] = useState(false)
    const [operationFoldId, setOperationFoldId] = useState()
    const {saveContentLoading,createSavedFoldLoading,deleteSavedContentLoading,saveContentAction, createSavedFoldAction, deleteSavedContentAction} = useMarkAction()
    const confirmCreate = (event) => {
        event.preventDefault();
        var form = document.getElementById('myCreateFoldForm')        
        const name = form.elements['fold_name'].value;
        const des = form.elements['fold_description'].value;
        // console.log(name, des)
        if(name){
            setNameEmpty(false)
            createSavedFoldAction({fold_name:name,fold_description:des}).then(res=>{setNameEmpty(false);setCreateFoldForm(false);savedFoldListRefresh()})
        }else{
            setNameEmpty(true)
        }
    }
    const nameOnChange = (event) => {
        const name = event.target.value
        if(name){
            setNameEmpty(false)
        }else{
            setNameEmpty(true)
        }
    }
    const reset = () => {
        setNameEmpty(false);setCreateFoldForm(false);
    }

    return (
        <dialog id="my_mark_modal" className="modal">
            <div className="modal-box p-0">
                <div className="bg-white p-4 sticky top-0">
                    <div className="flex space-between items-center">
                        <h2 className="card-title pl-4">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" />
                            </svg>
                            {createFoldForm ? '新建' : ''}收藏夹
                        </h2>
                        <form method="dialog">
                            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" onClick={()=>{reset()}}>✕</button>
                        </form>
                    </div>
                </div>
                <div className='px-8 pt-2 pb-6'>
                    {
                        createFoldForm ? 
                        <form id='myCreateFoldForm'>
                            <input name='fold_name' type="text" placeholder="文件夹名称" className={`input input-bordered w-full ${nameEmpty ? '' : 'mb-4'}`} onChange={nameOnChange}/>
                            {nameEmpty && <div className="label">
                                <span className="label-text-alt text-red-500">请输入文件夹名称！</span>
                            </div>}
                            <textarea name='fold_description' className="textarea textarea-bordered w-full mb-4" placeholder="文件夹描述（可选）"></textarea>
                            <div className="card-actions justify-center">
                                <button className="btn btn-ghost w-24" type='reset' onClick={()=>{setNameEmpty(false);setCreateFoldForm(false)}}>取消新建</button>
                                <button className='btn btn-outline w-24' type='submit' onClick={confirmCreate}>
                                    {createSavedFoldLoading ? <span className="loading loading-spinner"></span> : '确认新建'}
                                </button>
                            </div>
                        </form> :
                        <>
                            {
                                loading ? 
                                <div className="flex flex-col gap-4 w-full mb-2">
                                    <div className="skeleton h-6 w-full"></div>
                                    <div className="skeleton h-6 w-full"></div>
                                    <div className="skeleton h-6 w-full"></div>
                                </div> : 
                                <div>
                                    {
                                        data?.length > 0 ? 
                                        <div>
                                        {data?.map((item, index) => {return (
                                                <div className={`flex justify-between items-center w-full py-3 ${index===data?.length-1 ? '' : 'border-b'}`}>
                                                    <div>
                                                        <div className='text-lg font-bold truncate'>
                                                            {item?.fold_name}
                                                        </div>
                                                        <div className='text-secondary'>
                                                            {item?.content_len}条内容
                                                        </div>
                                                    </div>
                                                    {
                                                        item?.save_id_list?.includes(markData?.source_id) ?
                                                        <button className='btn btn-outline ml-6 btn-active w-24'
                                                        onClick={()=>{setOperationFoldId(item?.fold_id);deleteSavedContentAction({source_id:markData?.source_id,fold_id:item?.fold_id}).then(res=>savedFoldListRefresh())}}>
                                                            {deleteSavedContentLoading&&operationFoldId===item?.fold_id ? <span className="loading loading-spinner"></span> : '取消收藏'}
                                                        </button> :                                        
                                                        <button className='btn btn-outline ml-6 w-24'
                                                        onClick={()=>{setOperationFoldId(item?.fold_id);saveContentAction({...markData,fold_id:item?.fold_id}).then(res=>savedFoldListRefresh())}}>
                                                            {saveContentLoading&&operationFoldId===item?.fold_id ? <span className="loading loading-spinner"></span> : '收藏'}
                                                        </button>
                                                    }
                                                </div>
                                            )})} 
                                        </div>    
                                            :
                                        <div className="w-full text-center p-4">
                                            暂无内容
                                        </div>
                                    }
                                    <div className='w-full text-center mt-2'>
                                        <button className='btn btn-outline' onClick={()=>setCreateFoldForm(true)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v6m3-3H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" />
                                            </svg>
                                            新建收藏夹
                                        </button>
                                    </div>
                                </div>
                            }
                        </>
                    }
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={()=>{reset()}}>close</button>
            </form>
        </dialog>
    )
}